import { Theme } from '@mui/material';
import Color from 'color';

export const styles = (theme: Theme) => ({
  root: {
    padding: { tablet: '45px', mobile: '45px 15px' },
  },
  asideActions: {
    display: 'none',
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      flexDirection: 'row',
      display: 'flex',
      flex: 'none',
      marginBottom: '23px',
    },
  },
  pageTitle: {
    fontSize: '2rem',
    marginBottom: '16px',
  },
  sectionTitle: {
    fontSize: '1.3rem',
    marginBottom: '20px',
    color: Color(theme.palette.grayScale.main).alpha(0.6).hsl().toString(),
  },
  subtitle: {
    color: Color(theme.palette.grayScale.main).alpha(0.6).hsl().toString(),
    marginBottom: '10px',
  },
  actions: {
    display: 'flex',
    justifyContent: { tablet: 'flex-end', mobile: 'flex-start' },
    alignItems: 'flex-start',
    flex: 'auto',
  },
  grouping: {
    marginBottom: '5px',
  },
  sortSelect: {
    marginLeft: '5px',
    fontSize: '0.875rem',
  },
  sortSelectContainer: {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem',
      fontWeight: 700,
    },
  },
  formControl: {
    width: { tablet: '250px', mobile: '100%' },
  },
  empty: {
    color: Color(theme.palette.grayScale.main).hsl().alpha(0.6).toString(),
  },
  emptyTitle: {
    fontSize: '2.125rem',
    marginBottom: '15px',
  },
  label: {
    fontWeight: 700,
  },
  tips: {
    padding: 0,
    margin: 0,
    paddingInlineStart: '15px',
  },
  noRows: {
    padding: { tablet: '25px 25%', mobile: '25px 30px' },
  },
});

export default styles;
